var newClassManipulator = require('./classManipulator');

function negotiateSetRequired(element, model) {
	var classManipulator = newClassManipulator();
	if (model.isRequired)
		classManipulator.addTo(element, 'required');
}

module.exports = negotiateSetRequired;